<template>
	<div class="body">
		<div class="top-login-logo">
			<img src="http://alicdn.2cccc.cc/static/assets/img/logob.png" alt="" srcset="">
		</div>
		<div class="login-form">
			<div class="login-form-item">
				<el-input type="text" v-model="form.account" placeholder="请输入账号/ID"></el-input>
			</div>
			<div class="login-form-item">
				<el-input type="password" v-model="form.password"
					:placeholder="type==='forget'?'请输入新密码':'请输入密码'"></el-input>
			</div>
			<div style="display: flex;align-items: center;width: 300px;" v-if="type!=='login'">
				<div class="login-form-item" style="width: 200px;">
					<el-input type="text" v-model="form.verify_code" placeholder="请输入验证码"></el-input>
				</div>
				<el-link type="primary" style="margin-left: auto;font-size: 16px;" :underline="false"
					@click="dialogCodeVisible=true">发送验证码</el-link>
			</div>
			<div style="display: flex;align-items: center;padding:5px 0px;justify-content: flex-start;"
				v-if="type==='reg'">
				<el-checkbox v-model="checked" style="width: 65px;">我同意</el-checkbox>
				<el-link type="primary" style="font-size: 14px;" :underline="false"
					@click="dialogVisible=true">《权朗网络用户协议》</el-link>
			</div>
		</div>

		<div class="login-btn" @click="submit">
			{{type==='login'?'登 录':type==='forget'?'确认修改':'立即注册'}}
		</div>
		<div class="other">
			<el-link type="primary" @click="type='login'" v-if="type!=='login'">去登陆</el-link>
			<el-link type="primary" @click="type='reg'" v-if="type!=='reg'">注册账号</el-link>
			<el-link type="primary" @click="type='forget'" v-if="type=='login'">找回密码</el-link>
		</div>
		<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
			<iframe src="http://quanlang.top/user/index/user_agreement.html" width="100%" height="600px"
				style="font-size: 12px;background-color: #f8f8f8;border: 1px solid #dedede"></iframe>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false" size="small">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="dialogCodeVisible" width="340px">
			<div style="padding: 10px;display: flex;flex-direction: column;">
				<img src="http://alicdn.2cccc.cc/static//img/qrcode_qlwlkj.jpg" style="width: 100%;height: 100px;">
			</div>
			<div style="padding: 10px 10px 0px 10px;font-size: 14px;">
				关注公众号后点击下方管理中心，获取验证码
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogCodeVisible = false" size="small">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios'
	import {mapState} from 'vuex'
	export default {
		data() {
			return {
				dialogVisible: false,
				dialogCodeVisible: false,
				checked: false,
				type: 'login',
				form: {
					password: '',
					account: '',
					verify_code: '',
				}
			}
		},
		computed:{
			...mapState({
				uper:state=>state.uper
			})
		},
		methods: {
			submit() {
				let data = {}
				if (this.type === "login") {
					data = {
						password: this.form.password,
						account: this.form.account,
					}
					this.$H.post('quanlang/v1_0_1.Index/login', data).then(res => {
						if (res.data) {
							this.$store.dispatch('login', res.data.token).then(res => {
								this.$message.success('登录成功')
								setTimeout(() => {
									this.$router.push({
										name: 'index'
									})
								}, 500)

							})
						}
					});
				} else if (this.type === 'reg') {
					if (!this.checked) return this.$message.error('请先阅读《权朗网络用户协议》')
					data = {
						password: this.form.password,
						account: this.form.account,
						code: this.form.verify_code,
						uper:this.uper
					}
					this.$H.post('quanlang/v1_0_1.Index/regist', data).then(res => {
						console.log(res)
						if (res.data) {
							this.$message.success('注册成功')
							this.form = {
								password: '',
								account: '',
								verify_code: ''
							}
							this.type = 'login'
						}
					});

				} else if (this.type === 'forget') {
					data = {
						password: this.form.password,
						account: this.form.account,
						code: this.form.verify_code
					}
					this.$H.post('/quanlang/v1_0_1.Index/SetPwd', data).then(res => {
						console.log(res)
						if (res.data) {
							this.$message.success('密码重置成功')
							this.form = {
								password: '',
								account: '',
								verify_code: ''
							}
							this.type = 'login'
						}
					});
				}

			}
		}
	}
</script>

<style scoped>
	.body {
		display: flex;
		flex-direction: column;
		align-items: center;
		position: absolute;
		padding-top: 200px;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}

	.top-login-logo {
		max-width: 159px;
		height: 205px;
		margin: 0 auto;
		margin-bottom: 20px;
	}

	.login-form .login-form-item {
		border-bottom: 1px solid rgba(255, 255, 255, 0.2);
		width: 300px;
		margin-bottom: 10px;
	}

	.login-form .login-form-item /deep/.el-input__inner {
		background-color: #2C2D35 !important;
		border: 1px solid #2C2D35 !important;
		box-shadow: none !important;
		color: #b5b5b5;
		padding: 0;
	}

	.login-btn {
		width: 300px;
		height: 35px;
		border: 1px solid #b5b5b5;
		color: #b5b5b5;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		margin-top: 10px;
		cursor: pointer;
	}

	.login-btn:hover {
		color: #fff;
		background-color: #b5b5b5;
	}

	.other {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 300px;
		margin-top: 10px;
	}
</style>